import { withStyles } from '@material-ui/core';

import RepeatSchedule from './component';
import styles from './styles';

export default withStyles(styles)(RepeatSchedule);
